
import { Canvas } from "fabric";
import { cn } from "@/lib/utils";
import { Tool } from "@/hooks/use-canvas-setup";
import { ReactNode, useState } from "react";
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { IncisionTemplateItem } from "../components/IncisionTemplateItem";
import { Pencil, Scissors } from "lucide-react";

interface DrawToolsProps {
  canvas: Canvas | null;
  currentTool: string;
  onToolChange: (tool: Tool) => void;
  icon: ReactNode;
  label: string;
}

export const DrawTools = ({ 
  canvas, 
  currentTool, 
  onToolChange,
  icon,
  label
}: DrawToolsProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToolSelection = (tool: Tool) => {
    onToolChange(tool);
    setIsOpen(false);
  };

  return (
    <div className="toolbar-item">
      <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuTrigger asChild>
          <button
            className={cn(
              "modern-toolbar-button",
              (currentTool === "draw" || currentTool === "scalpel") && "active"
            )}
            aria-label={label}
          >
            {icon}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent 
          align="center" 
          className="modern-toolbar-dropdown w-40 p-1"
        >
          <IncisionTemplateItem
            icon={Pencil}
            label="Skin Marker"
            onClick={() => handleToolSelection("draw")}
            active={currentTool === "draw"}
          />
          <IncisionTemplateItem
            icon={Scissors}
            label="Scalpel"
            onClick={() => handleToolSelection("scalpel")}
            active={currentTool === "scalpel"}
          />
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
